module.exports = __webpack_public_path__ + "img/forgot-password.f1200f0b.svg";